//Importaciones
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { isNullUndefined } from '../../../../../../common/Helpers';
import { buildApexSeriesFromElements, getTop3BySegment, getTop3BySegment2 } from '../../../../../../common/Helpers/Portfolio_Contract_Compare_Segment';
import i18next from 'i18next';
import { ActionButton, DirectionalHint, Dropdown, IconButton, Toggle, TooltipHost } from '@fluentui/react';
import SidePanelSetSegments from './SidePanelSetSegments';
import SidePanelSetScopeSegments from './SidePanelSetScopeSegments';
import { cloneDeep, forEach } from 'lodash-es';
import { action_setCompareContracts_ChartData, action_setCompareContracts_Contratos, action_setCompareContracts_FireExecuteUseEffect_AgrupationSerieComponent, action_setCompareContracts_FireGetData, action_setCompareContracts_PanelSegmentValuesSelected, action_setCompareContracts_SegmentList, action_setCompareContracts_SegmentScope, action_setCompareContracts_SegmentSelected } from '../../../../../../reducers/actions/KPI/compareContractsActions';
import Loading from '../../../../../Templates/Site/Loading';
import { action_setPortfolio_Report_ElementIds } from '../../../../../../reducers/actions/SITE/portfolioActions';
import CLabel from '../../../../../Common/CLabel';

function CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE(props) {
    //Helpers
    const { t } = useTranslation();
	const dispatch = useDispatch();

    const { 
      inputParam_HideHeader = false,
      inputParam_ComponentContent = null,
    } = props;

	const { 
		_contratosParaGrafico: selectedContracts,
		_filtrosConfiguracion: filtrosConfiguracion,
		_contratosBase: contratosBase,
		_chartDataBaseStructure: chartDataBaseStructure,
		_chartDataBase: chartDataBase,
		_chartData: chartData,
		_segmentList: segmentList,
		_segmentScope: segmentScope,
		_pilarSeleccionado: pilarSeleccionado,
		_fireLoading: fireLoading,
		_fireUseEffectAgrupationSerieComponent: fireUseEffectAgrupationSerieComponent,
		_segmentSelected: segmentSelected,
		_panelSegmentValues: panelSegmentValues,
	} = useSelector((state) => state.compareContractsScope);

	const dropdownOptions = useMemo(() => {
		const baseOptions = filtrosConfiguracion.map(item => ({
			key: item.contractProp,
			text: t(item.dataLangKey)
		}));

		return [
			{
				key: '_SCOPE_',
				text: t('data-lang-lbl-portfolio-segmentscope')
			},
			...baseOptions
		];
	}, [filtrosConfiguracion, t]);

	const getLocalStorageValue = (key, defaultValue = null) => {
		const value = localStorage.getItem(key);

		if (value === null || value === undefined) {
			return defaultValue;
		}

		try {
			return JSON.parse(value);
		} catch (error) {
			// Compatibilidad con valores antiguos guardados como string plano:
			// supplierName, contractCode, etc.
			return value;
		}
	};

	const LOCAL_STORAGE_DEFAULT_SEGMENT_KEY = 'PARAM_COOKIE_TRANSVERSAL_PORTFOLIO_SEGMENT_CONFIG';

	const [selectedSegmentKey, setSelectedSegmentKey] = useState(() => {
		return getLocalStorageValue(LOCAL_STORAGE_DEFAULT_SEGMENT_KEY, null);
	});
	
	const setLocalStorageValue = (key, value) => {
		localStorage.setItem(key, JSON.stringify(value));
	};

	const [isPanelOpen, setIsPanelOpen] = useState(false);
	const [isScopePanelOpen, setIsScopePanelOpen] = useState(false);
	const [propertyToSearch, setPropertyToSearch] = useState(null);
	const leftContentRef = useRef(null);
	const [rightPanelHeight, setRightPanelHeight] = useState(null);
	const segmentBoxCardColors = [
		"#204a61",
		"#4d6978",
		"#4e86a3",
		"#5689b3",
		"#7098ad",
		"#4f9fc8",
		"#30a4c6",
		"#2fa1db",
		"#17BECF" 
	];

	const onOpenSidePanel = (property) => {
		setPropertyToSearch(property)
		setIsPanelOpen(true);
	}

	const onOpenSidePanelScope = () => {
		setIsScopePanelOpen(true);
	};

	const onOrderCardSegment = (property, sortDirection) => {
		const aux_segmentList = cloneDeep(segmentList);

		aux_segmentList.map((filterItem, indexFilter) => {
			if (filterItem.contractProp === property) {
				switch (sortDirection) {
					case 'asc':
						filterItem.sortDirection = 'desc';
						break;
					case 'desc':
						filterItem.sortDirection = 'asc';
						break;
					default:
						break;
				}

				filterItem.l_segment_values.sort((a, b) => { return filterItem.sortDirection === 'asc' ? a.valueAux - b.valueAux : b.valueAux - a.valueAux; });
			}
		})

		dispatch(action_setCompareContracts_SegmentList(aux_segmentList));
	}

	const onHeaderScopeClick = (segment) => {
		if (
			isNullUndefined(segment) ||
			isNullUndefined(segment.l_segment_values) ||
			segment.l_segment_values.length === 0
		) {
			return;
		}

		const aux_chartData = cloneDeep(chartData);

		const selectedElementIds = new Set(
			(!isNullUndefined(selectedContracts) ? selectedContracts : contratosBase)
				.map(x => x.elementId)
				.filter(x => !isNullUndefined(x))
		);

		const shouldFilterByElementId = selectedElementIds.size > 0;

		const scopeValues = segment.l_segment_values.filter(scopeItem =>
			!isNullUndefined(scopeItem.l_elements) &&
			scopeItem.l_elements.length > 0
		);

		const allElements = scopeValues.flatMap(scopeItem =>
			scopeItem.l_elements.filter(element =>
				!shouldFilterByElementId || selectedElementIds.has(element.elementId)
			)
		);

		/*const todosLosPeriodos = [
			...new Set(allElements.map(item => item.periodId))
		].sort((a, b) => Number(a) - Number(b));*/
		const todosLosPeriodos = chartDataBaseStructure.find(x => x.name === "OPF").l_vals.filter(x => x.elementId === 0).map(x => x.periodId.toString())

		const seriesPorScope = scopeValues.map(scopeItem => {
			const elements = scopeItem.l_elements.filter(element =>
				!shouldFilterByElementId || selectedElementIds.has(element.elementId)
			);

			const elementsByPeriod = Object.groupBy(elements, item => item.periodId);

			const data = todosLosPeriodos.map(periodId => {
				const registrosPeriodo = elementsByPeriod[periodId] || [];

				const valoresNumericos = registrosPeriodo
					.map(x => x.scopeValue)
					.filter(x => x !== null && x !== undefined && !isNaN(x))
					.map(Number);

				if (valoresNumericos.length === 0) {
					return null;
				}

				const promedioPeriodo =
					valoresNumericos.reduce((acc, value) => acc + value, 0) / valoresNumericos.length;

				return Math.round(promedioPeriodo);
			});

			return {
				name: scopeItem.name,
				data
			};
		});

		const titleSegmentSerie = aux_chartData.contractSeries.filter(item =>
			typeof item.name === "string" &&
			item.name.trim().startsWith("~") &&
			item.name.trim().endsWith("~")
		);
		const categories = chartDataBaseStructure.find(x => x.name === "OPF").l_vals.filter(x => x.elementId === 0).map(x => x.periodId.toString())
		aux_chartData.contractCategories = categories;
		aux_chartData.contractSeries = [
			...seriesPorScope,
			...titleSegmentSerie
		];

		dispatch(action_setCompareContracts_ChartData(aux_chartData));
		dispatch(action_setCompareContracts_SegmentSelected({
			titleSegment: segment.filterName,
			cardSegment: null,
			propertySegment: segment.contractProp
		}));
		dispatch(action_setCompareContracts_PanelSegmentValuesSelected(null));
	};

	const onOrderCardScopeSegment = (sortDirection) => {
		const aux_segmentScope = cloneDeep(segmentScope);

		switch (sortDirection) {
			case 'asc':
				aux_segmentScope.sortDirection = 'desc';
				break;
			case 'desc':
				aux_segmentScope.sortDirection = 'asc';
				break;
			default:
				break;
		}

		aux_segmentScope.l_segment_values.sort((a, b) => { return aux_segmentScope.sortDirection === 'asc' ? a.valueAux - b.valueAux : b.valueAux - a.valueAux; });

		dispatch(action_setCompareContracts_SegmentScope(aux_segmentScope));
	}

	const onCardScopeClick = (segmentName) => {
		const aux_chartDataBase = cloneDeep(chartDataBase);
		const pilarSegment = segmentScope.l_segment_values.find(x => x.name === segmentName);
		const seriesToShow = buildApexSeriesFromElements(pilarSegment);

		const categories = chartDataBaseStructure.find(x => x.name === "OPF").l_vals.filter(x => x.elementId === 0).map(x => x.periodId.toString())
		aux_chartDataBase.contractSeries = seriesToShow.series;
		aux_chartDataBase.contractCategories = categories;

		dispatch(action_setCompareContracts_ChartData(aux_chartDataBase))
		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: '_SCOPE_', cardSegment: segmentName, propertySegment: null}))
		dispatch(action_setCompareContracts_PanelSegmentValuesSelected(null))
	}

	const onHeaderClick = (segment, aux_segmentList) => {
		const currentSegmentList = isNullUndefined(aux_segmentList) ? segmentList : aux_segmentList;
		const currentPilarWithVals = chartDataBaseStructure.find(x => x.id === pilarSeleccionado.scopeId);
		const filteredItems = currentSegmentList.filter(item => item.contractProp === segment.contractProp).flatMap(item => item.l_segment_values.map(x => x.name));
		const setFiltredItems = new Set(filteredItems);
		const contracts = selectedContracts.filter(item => setFiltredItems.has(item[segment.contractProp]));
		const groupedItems = Object.groupBy(contracts, item => item[segment.contractProp]);
		const mapaValores = Object.groupBy(currentPilarWithVals.l_vals, item => item.elementId);
		const todosLosPeriodos = [...new Set(currentPilarWithVals.l_vals.map(item => item.periodId))].sort((a, b) => Number(a) - Number(b));

		const seriesPorGrupo = Object.entries(groupedItems).map(([nombreGrupo, elementos]) => {
			
			// 2. Calculamos los datos iterando estrictamente sobre la lista global de períodos
			const soloValores = todosLosPeriodos.map(periodId => {
				let sumaPeriodo = 0;
				let elementosContados = 0;

				elementos.forEach(elem => {
					const registrosElemento = mapaValores[elem.elementId] || [];
					const registroPeriodo = registrosElemento.find(r => r.periodId === periodId);

					const tieneValor =
						registroPeriodo &&
						registroPeriodo.scopeValue !== null &&
						registroPeriodo.scopeValue !== undefined;

					if (tieneValor) {
						sumaPeriodo += Number(registroPeriodo.scopeValue);
						elementosContados += 1;
					}
				});

				if (elementosContados === 0) {
					return null;
				}

				const promedioCrudo = sumaPeriodo / elementosContados;

				return Math.round(promedioCrudo);
			});

			const currentContract = contracts.find(x => x.contractCode === nombreGrupo)

			return {
				name: segment.contractProp === 'contractCode' ? `${nombreGrupo} - ${currentContract.supplierName}` : nombreGrupo,
				data: soloValores // Mantiene el orden exacto de 'todosLosPeriodos' automáticamente
			};
		});

		const aux_chartData = cloneDeep(chartData);
		const titleSegmentSerie = aux_chartData.contractSeries.filter(item => (item.name.trim().startsWith("~") && item.name.trim().endsWith("~")));
		const newSeries = [...seriesPorGrupo, ...titleSegmentSerie]

		aux_chartData.contractSeries = newSeries;

		dispatch(action_setCompareContracts_ChartData(aux_chartData))
		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: segment.filterName, cardSegment: null, propertySegment: segment.contractProp}))
		dispatch(action_setCompareContracts_PanelSegmentValuesSelected(null))
	}

	const onApplySegmentSerieClick = () => {
		const new_aux_chart_serie = getTop3BySegment2(selectedContracts, chartDataBaseStructure, segmentSelected.propertySegment, pilarSeleccionado.scopeId);
		const aux_chartData = cloneDeep(chartData);

		const titleSegmentSerie = aux_chartData.contractSeries.find(item => (item.name.trim().startsWith("~") && item.name.trim().endsWith("~")));

		const opfChartData = chartDataBaseStructure.find(x => x.name === 'OPF');


		if (isNullUndefined(titleSegmentSerie)) {
			let contractCategories = [];
			let aux_new_aux_chart_serie = [];

			if (opfChartData.l_vals.length > 0) {
				contractCategories = opfChartData.l_vals.map(x => x.periodId.toString()).filter((value, index, self) => self.indexOf(value) === index);
			}

			contractCategories.forEach(category => {
				const aux = new_aux_chart_serie.find(x => x.periodId.toString() === category)
				aux_new_aux_chart_serie.push(!isNullUndefined(aux) && !isNullUndefined(aux.scopeValue) ? parseFloat(aux.scopeValue.toFixed(2)) : null)
			})

			const new_chart_serie = {
				//data: new_aux_chart_serie.map(x => !isNullUndefined(x.scopeValue) ? parseFloat(x.scopeValue.toFixed(2)) : x.scopeValue),
				//data: new_aux_chart_serie.map(x => !isNullUndefined(x.scopeValue) ? parseFloat(x.scopeValue.toFixed(0)) : x.scopeValue),
				data: aux_new_aux_chart_serie.map(x => !isNullUndefined(x) ? Math.round(x) : x),
				isDashed: 5,
				name: `~ ${pilarSeleccionado.name} ~`
			};

			const isPromedio = item => typeof item.name === "string" && item.name.trim().startsWith("~") && item.name.trim().endsWith("~");
			const exists = aux_chartData.contractSeries.some(isPromedio);
			const newArray = exists ? aux_chartData.contractSeries.map(item => isPromedio(item) ? new_chart_serie : item) : [...aux_chartData.contractSeries, new_chart_serie];

			aux_chartData.contractSeries = newArray;
		}
		else {
			aux_chartData.contractSeries = aux_chartData.contractSeries.filter(x => x.name !== titleSegmentSerie.name);
		}

		dispatch(action_setCompareContracts_ChartData(aux_chartData))
		//dispatch(action_setCompareContracts_SegmentSelected({titleSegment: serieName, cardSegment: segmentSelected.cardSegment, propertySegment: property}))
	}

	
	const onChangeDefaultSegment = (event, option, index) => {
		if (!option) return;

		setSelectedSegmentKey(option.key);

		setLocalStorageValue(
			LOCAL_STORAGE_DEFAULT_SEGMENT_KEY,
			option.key
		);
	};

	const onCardClick = (property, segmentName) => {
		const aux_chartDataBase = cloneDeep(chartDataBase);
		const aux_chartData = cloneDeep(chartData);

		const seriesToShow = selectedContracts.filter(x => x[property] === segmentName).map(x => `${x.contractCode} - ${x.supplierName}`);
		
		const titleSegmentSerie = aux_chartData.contractSeries.filter(item => (item.name.trim().startsWith("~") && item.name.trim().endsWith("~")));
		const filtredSeries = aux_chartDataBase.contractSeries.filter(item => seriesToShow.some(filtro => filtro === item.name));
		
		const newSeries = [...filtredSeries, ...titleSegmentSerie]
		aux_chartDataBase.contractSeries = newSeries;

		dispatch(action_setCompareContracts_ChartData(aux_chartDataBase))
		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: segmentName, propertySegment: property}))
		dispatch(action_setCompareContracts_PanelSegmentValuesSelected(null))
	}

	const onClearSegment = () => {
		const aux_chartData = cloneDeep(chartDataBase);
		dispatch(action_setCompareContracts_ChartData(aux_chartData))
		dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: null, propertySegment: null}))
		dispatch(action_setCompareContracts_PanelSegmentValuesSelected(null))
	}

	const onRemovePanelSegment = (panelSegment) => {
		const itemNameToDelete = segmentSelected.propertySegment === 'contractCode' ? `${panelSegment.name} - ${panelSegment.supplierName}` : panelSegment.name;

		const panelSegments = panelSegmentValues.selectedSegments.filter(x => x.name !== panelSegment.name);
		const aux_chartData = cloneDeep(chartData);

		aux_chartData.contractSeries = aux_chartData.contractSeries.filter(x => x.name !== itemNameToDelete)

		if (aux_chartData.contractSeries.length === 0) {
			dispatch(action_setCompareContracts_ChartData(chartDataBase))
			dispatch(action_setCompareContracts_SegmentSelected({titleSegment: null, cardSegment: null, propertySegment: null}))
			dispatch(action_setCompareContracts_PanelSegmentValuesSelected(null))
		}
		else {
			dispatch(action_setCompareContracts_ChartData(aux_chartData))
			dispatch(action_setCompareContracts_PanelSegmentValuesSelected({ ...panelSegmentValues, selectedSegments: panelSegments }));
		}
	}

	const getContractAditionalData = (contractCode) => {
        const contract = contratosBase.find(x => x.contractCode === contractCode);
        
        return !isNullUndefined(contratosBase) && contratosBase.length > 0 ? `${contract.contractCode} - ${contract.supplierName}` : ''
    }

	useEffect(() => {
		const getAverage = (values) => {
			const numericValues = values
				.map(x => x.scopeValue)
				.filter(x => x !== null && x !== undefined && !isNaN(x));

			if (numericValues.length === 0)
				return null;

			return numericValues.reduce((acc, value) => acc + Number(value), 0) / numericValues.length;
		};

        const doit = async () => {
			const result = filtrosConfiguracion.map((filterItem, indexFilter) => {
				const l_segment_values = [
					...new Set(
						(!isNullUndefined(selectedContracts) ? selectedContracts : contratosBase)
							.map(item => item[filterItem.contractProp])
							.filter(value => value !== null && value !== undefined && value !== "")
					)
				];

				const aux_values = getTop3BySegment((!isNullUndefined(selectedContracts) ? selectedContracts : contratosBase), chartDataBaseStructure, filterItem.contractProp, pilarSeleccionado.scopeId);

				return {
					filterName: t(filterItem.dataLangKey),
					contractProp: filterItem.contractProp,
					sortDirection: 'desc',
					color: segmentBoxCardColors[indexFilter],
					l_segment_values: l_segment_values.map((item, index) => {
						const itemFound = aux_values.find(x => x.key === item);
						return {
							name: item,
							value: !isNullUndefined(itemFound.avg) ? Math.round(itemFound.avg) : t('no-data'),
							valueAux: itemFound.avg,
							supplierName: filterItem.contractProp === 'contractCode' ? selectedContracts.find(x => x.contractCode === item).supplierName : null
						};
					}).sort((a, b) => b.valueAux - a.valueAux)
				};
			});


			const resultScopes = {
				filterName: t('data-lang-lbl-portfolio-segmentscope'),
				contractProp: '_SCOPE_',
				sortDirection: 'desc',
				color: '#c9c9c9',
				l_segment_values: chartDataBaseStructure
					.filter(x => x.name !== "OPF")
					.map(parentItem => {
						const valueAux = getAverage(parentItem.l_vals);

						return {
							name: parentItem.name,
							value: !isNullUndefined(valueAux) ? Math.round(valueAux) : t('no-data'),
							valueAux,
							l_elements: parentItem.l_vals.map(val => {
								const contractFound = contratosBase.find(x => x.elementId === val.elementId);

								return {
									elementId: val.elementId,
									contractCode: contractFound?.contractCode ?? "",
									supplierName: contractFound?.supplierName ?? "",
									periodId: val.periodId,
									scopeValue: Math.round(val.scopeValue)
								};
							})
						};
					})
					.sort((a, b) => (b.valueAux ?? -Infinity) - (a.valueAux ?? -Infinity))
			}	

			dispatch(action_setCompareContracts_SegmentList(result))
			dispatch(action_setCompareContracts_SegmentScope(resultScopes))
			dispatch(action_setCompareContracts_FireExecuteUseEffect_AgrupationSerieComponent(true))

			const defaultSegment = filtrosConfiguracion.find(x => x.selectedSegment === true);
			if (isNullUndefined(selectedSegmentKey)) {
				if (isNullUndefined(defaultSegment)) {
					onHeaderScopeClick(resultScopes)
				}
				else {
					const resultSegment = result.find(x => x.contractProp === defaultSegment.contractProp);
					onHeaderClick(resultSegment, result)
				}
			}
			else {
				const resultSegment = result.find(x => x.contractProp === selectedSegmentKey);
				onHeaderClick(resultSegment, result)
			}
        }

		if ((fireUseEffectAgrupationSerieComponent === false || segmentList === null) && !isNullUndefined(filtrosConfiguracion) && !isNullUndefined(chartData) && !isNullUndefined(selectedContracts) && !isNullUndefined(contratosBase) && !isNullUndefined(chartDataBaseStructure)) {
			doit();
		}
	}, [fireUseEffectAgrupationSerieComponent, filtrosConfiguracion, selectedContracts, contratosBase, chartDataBaseStructure, chartData]);

	useLayoutEffect(() => {
		const updateRightPanelHeight = () => {
			if (!leftContentRef.current) return;

			const height = leftContentRef.current.getBoundingClientRect().height;
			setRightPanelHeight(height);
		};

		updateRightPanelHeight();

		const resizeObserver = new ResizeObserver(updateRightPanelHeight);

		if (leftContentRef.current) {
			resizeObserver.observe(leftContentRef.current);
		}

		window.addEventListener('resize', updateRightPanelHeight);

		return () => {
			resizeObserver.disconnect();
			window.removeEventListener('resize', updateRightPanelHeight);
		};
	}, [segmentList]);

	const renderContentDynamic = () => {
		return (
			<Row className="align-items-start">
				<Col xl={9}>
					<div ref={leftContentRef}>
						<Row className='border'>
							{
								segmentScope &&
								<Col 
									className='col-4 pb-1 border' 
									style={{fontWeight: 'bold'}}
								>
									<Row 
										className='mx-0 p-0'
										style={
											segmentSelected.titleSegment === segmentScope.filterName ? {
												textDecoration: 'underline',
												textUnderlineOffset: '5px',
												textDecorationThickness: '3px',
												textDecorationColor: segmentScope.color,
												textDecorationStyle: 'solid',
												backgroundImage: 'linear-gradient(to right, #ffffff, #e2e2e2)',
											} : undefined
										}
									>
										<Col 
											xl={7} 
											className='col-auto me-auto pt-1 cursor-pointer p-0' 
											onClick={() => onHeaderScopeClick(segmentScope)}
										>
											{`${segmentScope.filterName} (${ !isNullUndefined(segmentScope) ? segmentScope.l_segment_values.length : 0})`}
										</Col>

										<Col className='col-auto ms-auto p-0'>
											<ActionButton 
												iconProps={{
													iconName: segmentScope.sortDirection === 'desc' 
														? "DoubleChevronDown8" 
														: "DoubleChevronUp8"
												}} 
												onClick={() => onOrderCardScopeSegment(segmentScope.sortDirection)} 
												text={
													segmentScope.sortDirection === 'desc' 
														? t('data-lang-lbl-descending') 
														: t('data-lang-lbl-ascending')
												} 
											/>
											<IconButton 
												iconProps={{ iconName: "More" }} 
												onClick={onOpenSidePanelScope} 
											/>
										</Col>
									</Row>
									<Row>
										<Col>
										{
											segmentScope.l_segment_values.slice(0, 6).map((segmentItem, indexItemValue) => (
											<Row 
												key={indexItemValue} 
												className='p-0 m-0 cursor-pointer text-center' 
												onClick={() => onCardScopeClick(segmentItem.name)}
												style={
												segmentSelected.cardSegment === segmentItem.name ? {
													borderWidth: '3px',
													borderColor: segmentScope.color,
													borderStyle: 'revert-layer',
													color: '#000000',
													backgroundColor:'#e3e3e3'
												} : {
													backgroundColor: segmentScope.color, 
													color: 'white'
												}
												}
											>
												<Col className='cursor-pointer p-0 m-0'>
												<Row className='mx-0' style={{border: 'solid 1px white'}}>
													
													<Col 
													className='col-auto me-auto'
													style={{
														minWidth: 0,
														maxWidth: "85%"
													}}
													>
													<TooltipHost
														content={segmentScope.contractProp === "contractCode" ? getContractAditionalData(segmentItem.name) : segmentItem.name}
														directionalHint={DirectionalHint.topCenter}
													>
														<div
														style={{
															overflow: "hidden",
															textOverflow: "ellipsis",
															whiteSpace: "nowrap"
														}}
														>
														{segmentScope.contractProp === "contractCode" ? getContractAditionalData(segmentItem.name) : segmentItem.name}
														</div>
													</TooltipHost>
													</Col>

													<Col className='col-auto ms-auto'>
													{`${segmentItem.value}${segmentItem.value !== t('no-data') ? '%' : ''}`}
													</Col>

												</Row>	
												</Col>
											</Row>
											))
										}
										</Col>
									</Row>
								</Col>
							}
							{
								segmentList && segmentList.map((resultItem, index) => (
									<Col 
										key={index} 
										className='col-4 pb-1 border' 
										style={{fontWeight: 'bold'}}
									>
										<Row 
											className='mx-0 p-0'
											style={
												segmentSelected.titleSegment === resultItem.filterName ? {
													textDecoration: 'underline',
													textUnderlineOffset: '5px',
													textDecorationThickness: '3px',
													textDecorationColor: resultItem.color,
													textDecorationStyle: 'solid',
													backgroundImage: 'linear-gradient(to right, #ffffff, #e2e2e2)',
												} : undefined
											}
										>
											<Col 
												xl={7} 
												className='col-auto me-auto pt-1 cursor-pointer p-0' 
												onClick={() => onHeaderClick(resultItem)}
											>
												{`${resultItem.filterName} (${resultItem.l_segment_values.length})`}
											</Col>

											<Col className='col-auto ms-auto p-0'>
												<ActionButton 
													iconProps={{
														iconName: resultItem.sortDirection === 'desc' 
															? "DoubleChevronDown8" 
															: "DoubleChevronUp8"
													}} 
													onClick={() => onOrderCardSegment(resultItem.contractProp, resultItem.sortDirection)} 
													text={
														resultItem.sortDirection === 'desc' 
															? t('data-lang-lbl-descending') 
															: t('data-lang-lbl-ascending')
													} 
												/>
												<IconButton 
													iconProps={{iconName: "More"}} 
													onClick={() => onOpenSidePanel(resultItem.contractProp)} 
												/>
											</Col>
										</Row>

										<Row>
											<Col>
											{
												resultItem.l_segment_values.slice(0, 6).map((segmentItem, indexItemValue) => (
												<Row 
													key={indexItemValue} 
													className='p-0 m-0 cursor-pointer text-center' 
													onClick={() => onCardClick(resultItem.contractProp, segmentItem.name)}
													style={
													segmentSelected.cardSegment === segmentItem.name ? {
														borderWidth: '3px',
														borderColor: resultItem.color,
														borderStyle: 'revert-layer',
														color: '#000000',
														backgroundColor:'#e3e3e3'
													} : {
														backgroundColor: resultItem.color, 
														color: 'white'
													}
													}
												>
													<Col className='cursor-pointer p-0 m-0'>
													<Row className='mx-0' style={{border: 'solid 1px white'}}>
														
														<Col 
														className='col-auto me-auto'
														style={{
															minWidth: 0,
															maxWidth: "85%"
														}}
														>
														<TooltipHost
															content={resultItem.contractProp === "contractCode" ? getContractAditionalData(segmentItem.name) : segmentItem.name}
															directionalHint={DirectionalHint.topCenter}
														>
															<div
															style={{
																overflow: "hidden",
																textOverflow: "ellipsis",
																whiteSpace: "nowrap"
															}}
															>
															{resultItem.contractProp === "contractCode" ? getContractAditionalData(segmentItem.name) : segmentItem.name}
															</div>
														</TooltipHost>
														</Col>

														<Col className='col-auto ms-auto'>
														{`${segmentItem.value}${segmentItem.value !== t('no-data') ? '%' : ''}`}
														</Col>

													</Row>	
													</Col>
												</Row>
												))
											}
											</Col>
											</Row>
									</Col>
								))
							}
						</Row>
					</div>
				</Col>

				<Col className="p-0 m-0">
					{
						segmentList && 
						<div
							className="border d-flex flex-column w-100"
							style={{
								height: rightPanelHeight ? `${rightPanelHeight}px` : 'auto',
								maxHeight: rightPanelHeight ? `${rightPanelHeight}px` : 'none',
								overflow: 'hidden',
								minHeight: 0
							}}
						>
							<Row className='mx-0 p-0 flex-shrink-0' style={{fontWeight: 'bold'}}>
								<Col xl={8} className='col-auto me-auto pt-1 p-0 px-2'>
									{`${'Elementos de paneles'} (${ !isNullUndefined(panelSegmentValues) ? panelSegmentValues.selectedSegments.length : 0})`}
								</Col>

								<Col className='col-auto ms-auto p-0' style={{height: '40px'}}>
								</Col>
							</Row>

							<div
								style={{
									flex: '1 1 auto',
									minHeight: 0,
									overflowY: 'auto',
									overflowX: 'hidden'
								}}
							>
								{
									panelSegmentValues && panelSegmentValues.selectedSegments.map((segmentItem, indexItemValue) => (
										<Row 
											key={indexItemValue} 
											className='p-0 m-0 mx-2 text-center' 
											style={{
												backgroundColor: '#797979', 
												color: 'white', 
												fontWeight: 'bold'
											}}
										>
											<Col className='p-0 m-0'>
												<Row className='mx-0' style={{border: 'solid 1px white'}}>
													<Col className='col-auto me-auto'>
														{`${segmentItem.auxTitleSegment} - ${segmentItem.name}`}
													</Col>
													<Col className='col-auto ms-auto p-0 m-0'>
														{`${segmentItem.value}${segmentItem.value !== t('no-data') ? '%' : ''}`}&nbsp;&nbsp;
														<IconButton 
															iconProps={{iconName: "Delete"}} 
															styles={{
																root: {
																	backgroundColor: "white"
																}
															}} 
															onClick={() => onRemovePanelSegment(segmentItem)}
														/>
													</Col>
												</Row>	
											</Col>
										</Row>
									))
								}

								{
									!panelSegmentValues &&
									<div 
										className="h-100 d-flex align-items-center justify-content-center text-center"
										style={{padding: '8px'}}
									>
										{'Aquí aparecerán los elementos seleccionados de los paneles laterales.'}
									</div>
								}
							</div>
						</div>
					}
				</Col>
			</Row>
		);
	};

    //Render de componente.
    return (<>
				<Card>
					{
						!inputParam_HideHeader &&
						<Card.Header className="card-header-compact">
								<Card.Title className="d-flex justify-content-between">
									{ 
										pilarSeleccionado && <b>{`${(inputParam_ComponentContent !== null) ?
												(inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-group_filter_agroupation')) :
												t('data-lang-boxname-group_filter_agroupation')} - ${pilarSeleccionado.name}`}</b>
									}
									<div className='toolbar d-flex'>
										{
											filtrosConfiguracion &&
											<div className='d-flex'>
												<div className='pe-1 col mt-2' style={{fontSize:'14px'}}><b>{`${t('Segmentación por defecto')}:`}</b></div>
												<div className='ps-0 ms-0'>
													<Dropdown
														placeholder={t('data-lang-placeholder-selectoption')}
														options={dropdownOptions}
														selectedKey={selectedSegmentKey}
														onChange={onChangeDefaultSegment}
														style={{ width: '200px' }}
													/>
												</div>
											</div>
										}
										{
											pilarSeleccionado && chartData &&
											<ActionButton
												iconProps={{iconName: "Filter"}}
												text={`${isNullUndefined(chartData.contractSeries.find(item => typeof item.name === "string" && item.name.trim().startsWith("~") && item.name.trim().endsWith("~"))) ? t('data-lang-btn-viewpilar') : t('data-lang-btn-hidepilar')} ${pilarSeleccionado.name}`} onClick={onApplySegmentSerieClick} />
										}
										{
											pilarSeleccionado && !chartData &&
											<ActionButton iconProps={{iconName: "Filter"}} text={`Visualizar ${pilarSeleccionado.name}`} disabled={true} />
										}
										{
											(!isNullUndefined(segmentSelected.titleSegment) || !isNullUndefined(segmentSelected.cardSegment)) &&
											<ActionButton iconProps={{iconName: "RemoveFilter"}} text={t('data-lang-btn-clearsegment')} onClick={onClearSegment} />
										}
										{
											(isNullUndefined(segmentSelected.titleSegment) && isNullUndefined(segmentSelected.cardSegment)) &&
											<ActionButton iconProps={{iconName: "RemoveFilter"}} text={t('data-lang-btn-clearsegment')} disabled={true} />
										}
									</div>
								</Card.Title>
						</Card.Header>
					}
					<Card.Body className='m-0'>
						{ 	!fireLoading && (chartDataBaseStructure && pilarSeleccionado && chartData) && renderContentDynamic() }
						{ 
							fireLoading && (!(chartDataBaseStructure || pilarSeleccionado) && isNullUndefined(segmentList)) &&
							<Loading
								inputParam_Style={{marginTop: 0}}
								inputParam_Width = '30px'
								inputParam_Height = '30px'
							/>
						}
						{
							!fireLoading && !(chartDataBaseStructure && pilarSeleccionado && chartData) &&
							<Row className='text-center'><Col>{t('data-lang-msg-selectcontractandpillartocontinue')}</Col></Row>
						}
						{ 
							fireLoading && !(chartDataBaseStructure && pilarSeleccionado && chartData) &&
							<Loading
								inputParam_Style={{marginTop: 0}}
								inputParam_Width = '30px'
								inputParam_Height = '30px'
							/>
						}
					</Card.Body>
				</Card>
				{
					isPanelOpen === true &&
					<SidePanelSetSegments
						inputParam_IsPanelOpen={isPanelOpen}
						inputParam_SetterIsPanelOpen={setIsPanelOpen}
						inputParam_PropertyToSearch={propertyToSearch}
					/>
				}
				{
					isScopePanelOpen === true &&
					<SidePanelSetScopeSegments
						inputParam_IsPanelOpen={isScopePanelOpen}
						inputParam_SetterIsPanelOpen={setIsScopePanelOpen}
					/>
				}
			</>
    );
}

CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE.propTypes = {
	inputParam_BoardId: PropTypes.number.isRequired,
	inputParam_UseFake: PropTypes.bool.isRequired,
	inputParam_HideHeader: PropTypes.bool.isRequired,
	inputParam_ComponentContent: PropTypes.object.isRequired,
};

export default CONSOLIDATE_GROUP_CONTRACT_FILTER_AGRUPATION_SERIE;